import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {StorageService} from '../../../shared/services/storage.service';
import {StateService} from '../../../shared/services/state.service';
import {WizardComponent} from 'angular-archwizard';
import {StudentService} from '../../../shared/services/student.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {FileService} from '../../../shared/services/file.service';
import {PersonalInfoService} from '../../../shared/services/personal-info.service';
import {AlertService} from '../../../shared/services/alert.service';
import {AppConstants} from '../../../shared/constants/app-constant';
import {AddressService} from '../../../shared/services/address.service';
import {AcademicDetailsService} from '../../../shared/services/academic-details.service';
import {MoreQualificationsService} from '../../../shared/services/more-qualifications.service';
import {ProgramService} from '../../../shared/services/program.service';
import {PcbMappingService} from '../../../shared/services/pcb-mapping.service';
import {Helper} from '../../../shared/constants/helper';
import {CourseDetailsService} from '../../../shared/services/course-details.service';
import {CourseCurriculumService} from '../../../shared/services/course-curriculum.service';
import {ActivatedRoute, Router} from "@angular/router";
import {PaymentService} from "../../../shared/services/payment.service";
import {CountryService} from "../../../shared/services/country.service";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ps-application-form',
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.scss']
})
export class ApplicationFormComponent implements OnInit {
  personalInfoForm: FormGroup;
  addressForm: FormGroup;
  academicDetailsForm: FormGroup;
  moreQualificationForm: FormGroup;
  courseDetailForm: FormGroup;
  maxDate: Date;
  user: any;
  states: any = [];
  @ViewChild(WizardComponent)
  public wizard: WizardComponent;
  modalType: any;
  imageChangedEvent: any;
  croppedImage: any;
  croppedImageEvent: any;
  photographImageUploadArea: any = 'assets/images/image-backgrounds/200-200.png';
  filePhotograph: any;
  photographImage: any;
  imageChangedProfileEvent: any;
  fileGovtPhotoId: any;
  onFileChanged: any;
  submitting: any = false;
  submitted: any = false;
  categories: any = AppConstants.categories;
  employmentStatuses: any = AppConstants.employementStatuses;
  localityStatuses: any = AppConstants.localityStatuses;
  fileTenthCertificate: any;
  fileTwelthCertificate: any;
  fileGraduationCertificate: any;
  filePostGraduationCertificate: any;
  fileOtherQualificationCertificate: any;
  programs: any = [];
  courses: any = [];
  branches: any = [];
  selectedProgram: any = [];
  courseCurriculumData: any;
  selectedSessionId: any;
  selectedPCBMapping: any;
  appliedBy: any;
  docSubmittingPhotograph: any = false;
  docSubmittingGovtPhotoId: any = false;
  docSubmittingTenthCertificate: any = false;
  docSubmittingTwelthCertificate: any = false;
  docSubmittingGraduationCertificate: any = false;
  docSubmittingPostGraduationCertificate: any = false;
  docSubmittingOtherQualificationCertificate: any = false;
  submittedForm = true;
  studentData: any;
  selectedDocumentType: string;
  fileAadharFrontSide: any;
  fileAadharBackSide: any;
  fileVoterId: any;
  filePanCard: any;
  fileDrivingLicence: any;
  fileOtherGovermentID: any;
  signChangedEvent: any;
  signImage: any;
  selectedStudent: any;
  fileSignature: any;
  signChangedProfileEvent: any;
  country: any = [];


  constructor(private _formBuilder: FormBuilder,
              private toaster: ToastrService,
              private route: ActivatedRoute,
              private stateService: StateService,
              private countryService: CountryService,
              private studentService: StudentService,
              private fileService: FileService,
              private personalInfoService: PersonalInfoService,
              private addressService: AddressService,
              private alertService: AlertService,
              private academicDetailsService: AcademicDetailsService,
              private moreQualificationsService: MoreQualificationsService,
              private programService: ProgramService,
              private pcbMappingService: PcbMappingService,
              private courseDetailsService: CourseDetailsService,
              private courseCurriculumService: CourseCurriculumService,
              public modalService: NgbModal,
              private router: Router,
              private paymentService: PaymentService) {
    this.maxDate = new Date();
    this.user = StorageService.getItem('self');
    const queryParams  = this.route.snapshot.queryParamMap;
    const orderId = queryParams.get('order_id');
    if(orderId) {
      this.checkOrderId(orderId);
    }
  }

  ngOnInit(): void {
    this.personalInfoForm = this._formBuilder.group({
      application_no: [{'value': this.user.username, disabled: true}],
      session_id: [{'value': '', disabled: true}],
      admission_type: ['', Validators.required],
      year: [{'value': '', disabled: true}],
      name: [{'value': this.user.name, disabled: true}],
      name_hindi: ['', Validators.required],
      email: [{'value': this.user.email, disabled: true}],
      father_name: ['', Validators.required],
      father_name_hindi: ['', Validators.required],
      mother_name: ['', Validators.required],
      mother_name_hindi: ['', Validators.required],
      contact: [{'value': this.user.contact, disabled: true}],
      gender: ['', Validators.required],
      dob: ['', Validators.required],
      abc_id_no: [''],
      deb_unique_id: [''],
      government_id_type: [''],
      govt_photo_id_no: ['', Validators.compose([Validators.required, Validators.pattern('^[1-9]{1}[0-9]{11}$')])],
    });

    this.addressForm = this._formBuilder.group({
      address: ['', Validators.required],
      state_id: ['', Validators.required],
      country_id: ['', Validators.required],
      city: ['', Validators.required],
      pin_code: ['', Validators.required],
      nationality: [{'value': 'Indian', disabled: true}],
      category: ['', Validators.required],
      employment_status: ['', Validators.required],
      locality: ['', Validators.required],
    });

    this.academicDetailsForm = this._formBuilder.group({
      tenth_board: [null, Validators.required],
      tenth_subjects: ['', Validators.required],
      tenth_year_of_passing: [null, Validators.required],
      tenth_division_grade: ['', Validators.required],
      twelth_board: [null, Validators.required],
      twelth_subjects: ['', Validators.required],
      twelth_year_of_passing: [null, Validators.required],
      twelth_division_grade: ['', Validators.required],
      highest_qualification: ['', Validators.required],
    });

    this.moreQualificationForm = this._formBuilder.group({
      graduation_university: [''],
      graduation_course: [''],
      graduation_year_of_passing: [''],
      graduation_division_grade: [''],
      post_graduation_university: [''],
      post_graduation_course: [''],
      post_graduation_year_of_passing: [''],
      post_graduation_division_grade: [''],
      other_qualification_university: [''],
      other_qualification_course: [''],
      other_qualification_year_of_passing: [''],
      other_qualification_division_grade: [''],
    });

    this.courseDetailForm = this._formBuilder.group({
      program_id: ['', Validators.required],
      course_id: ['', Validators.required],
      branch_id: ['']
    });

    this.getStates();
    this.getCountry();
    this.getPrograms();
  }
  checkOrderId(data) {
    const params = {
      order_id : data,
    }
    this.studentService.checkOrderId(params).subscribe(fs => {
      if(fs && fs['data'] && fs['data']['status'] && (fs['data']['status'] == "success") && fs['data']['data'] && fs['data']['data']['status'] && (fs['data']['data']['status'] == "paid") )
      {
        this.selectedStudent = fs['data']['data'];
        const params = {
          'user_id': this.selectedStudent["notes"][0]['value'],
          'session_id': this.selectedStudent["notes"][1]['value'],
          'payment_type': this.selectedStudent["notes"][2]['value'],
          'paid_at' : this.selectedStudent['paid_at'],
          'amount': this.selectedStudent["details"][0]['amount'],
        }
        this.studentService.paymentResponse(params).subscribe(data => {
        }, error => {
          this.router.navigateByUrl('/general/application-form')
        })
      }
      else {
       this.router.navigateByUrl('/general/application-form')
      }
    }, error => {
      this.router.navigateByUrl('/general/application-form')
    });
  }
  getStates() {
    this.stateService.get().subscribe(data => {
      if (data && data['data'].length > 0) {
        this.states = data['data'];
        this.getStudentDetail();
      }
    });
  }
  getCountry() {
    this.countryService.get().subscribe(data => {
      this.country = data['data'];
    });
  }
  getPrograms() {
    this.programs = [];
    this.programService.get({'page': -1, 'status': 'ACTIVE'}).subscribe(data => {
      if (data && data['data'].length > 0) {
        this.programs = data['data'];
      }
    });
  }

  getCourses(event) {
    if (event.target.value) {
      this.courses = [];
      this.branches = [];
      this.pcbMappingService.get({'page': -1, 'status': 'ACTIVE', 'program_id': event.target.value}).subscribe(data => {
        if (data && data['data'].length > 0) {
          this.courses = Helper.uniqByKeepLast(data['data'], it => it.course_id);
          this.courseDetailForm.patchValue({
            'course_id': '',
            'branch_id': ''
          });
        }
      });
    } else {
      this.alertService.showErrors('Something went wrong, please select program again');
    }
  }

  getCoursesByProgramId(program_id, data) {
    if (program_id) {
      this.courses = [];
      this.branches = [];
      this.pcbMappingService.get({'page': -1, 'status': 'ACTIVE', 'program_id': program_id}).subscribe(dt => {
        if (dt && dt['data'].length > 0) {
          this.courses = Helper.uniqByKeepLast(dt['data'], it => it.course_id);
          if (this.courses && this.courses.length > 0) {
            this.courseDetailForm.patchValue({
              'course_id': data['course_id']
            });
            this.getBranchesByCourseId(data);
          }
        }
      });
    } else {
      this.alertService.showErrors('Something went wrong, please select program again');
    }
  }
  onSignChange(e) {
    this.signChangedEvent = e;
  }
  getBranches(event) {
    if (event.target.value) {
      this.branches = [];
      this.pcbMappingService.get({'page': -1, 'status': 'ACTIVE', 'course_id': event.target.value}).subscribe(data => {
        if (data && data['data'].length > 0) {
          const branches = [];
          data['data'].forEach(dt => {
            if (dt && dt.branch_id) {
              branches.push(dt);
            }
          });
          this.branches = Helper.uniqByKeepLast(branches, it => it.branch_id);
        }
      });
    } else {
      this.alertService.showErrors('Something went wrong, please select program again');
    }
  }

  getBranchesByCourseId(data) {
    if (data && data['course_id']) {
      this.branches = [];
      this.pcbMappingService.get({'page': -1, 'status': 'ACTIVE', 'course_id': data['course_id']}).subscribe(db => {
        if (db && db['data'].length > 0) {
          const branches = [];
          db['data'].forEach(dt => {
            if (dt && dt.branch_id) {
              branches.push(dt);
            }
          });
          this.branches = Helper.uniqByKeepLast(branches, it => it.branch_id);
          if (this.branches && this.branches.length > 0 && data['branch_id']) {
            this.courseDetailForm.patchValue({
              'branch_id': data['branch_id']
            });
            this.getPCBMapping(data);
          } else {
            this.getPCBMapping(data);
          }
        }
      });
    } else {
      this.alertService.showErrors('Something went wrong, please select program again');
    }
  }

  getPCBMapping(data) {
    let params = {};
    if (data && data['branch_id']) {
      params = {
        'program_id': data['program_id'],
        'course_id': data['course_id'],
        'branch_id': data['branch_id']
      };
    } else {
      params = {
        'program_id': data['program_id'],
        'course_id': data['course_id']
      };
    }
    this.pcbMappingService.get(params).subscribe(dt => {
      if (dt && dt['data'].length > 0) {
        this.selectedPCBMapping = dt['data'][0];
        this.getCourseCurriculum(dt['data'][0]['id'], data);
      }
    });
  }

  getCourseCurriculum(pcbMappingId, data) {
    this.courseCurriculumService.detail(pcbMappingId, {'session_id': data['session_id']}).subscribe(dt => {
      if (dt && dt['data'].length > 0) {
        this.courseCurriculumData = {
          'course_fee': parseFloat(dt['data'][0]['course_fee']),
          'prospectus_fee': parseFloat(dt['data'][0]['prospectus_fee']),
          'registration_amount': parseFloat(dt['data'][0]['registration_amount']),
          'service_charge': parseFloat(dt['data'][0]['service_charge']),
          'examination_fee': parseFloat(dt['data'][0]['examination_fee']),
          'total_fee': parseFloat(dt['data'][0]['course_fee']) + parseFloat(dt['data'][0]['prospectus_fee']) + parseFloat(dt['data'][0]['registration_amount']) + parseFloat(dt['data'][0]['examination_fee']) + parseFloat(dt['data'][0]['service_charge']),
          'total_fee_without_registration': parseFloat(dt['data'][0]['course_fee']) + parseFloat(dt['data'][0]['prospectus_fee'])  + parseFloat(dt['data'][0]['examination_fee']) + parseFloat(dt['data'][0]['service_charge']),
        };
      }
    });
  }

  getStudentDetail() {
    this.studentService.detail().subscribe(data => {
      if (data) {
        this.studentData = data;
        this.appliedBy = data.applied_by;

        if (data && data.edit_status && data.edit_status === 'DISALLOW') {
          this.personalInfoForm.controls['admission_type'].disable();
          this.personalInfoForm.controls['name_hindi'].disable();
          this.personalInfoForm.controls['father_name'].disable();
          this.personalInfoForm.controls['father_name_hindi'].disable();
          this.personalInfoForm.controls['mother_name'].disable();
          this.personalInfoForm.controls['mother_name_hindi'].disable();
          this.personalInfoForm.controls['gender'].disable();
          this.personalInfoForm.controls['dob'].disable();
          this.personalInfoForm.controls['abc_id_no'].disable();
          this.personalInfoForm.controls['deb_unique_id'].disable();
          this.personalInfoForm.controls['govt_photo_id_no'].disable();

          this.addressForm.controls['address'].disable();
          this.addressForm.controls['state_id'].disable();
          this.addressForm.controls['country_id'].disable();
          this.addressForm.controls['city'].disable();
          this.addressForm.controls['pin_code'].disable();
          this.addressForm.controls['category'].disable();
          this.addressForm.controls['employment_status'].disable();
          this.addressForm.controls['locality'].disable();

          this.academicDetailsForm.controls['tenth_board'].disable();
          this.academicDetailsForm.controls['tenth_subjects'].disable();
          this.academicDetailsForm.controls['tenth_year_of_passing'].disable();
          this.academicDetailsForm.controls['tenth_division_grade'].disable();
          this.academicDetailsForm.controls['twelth_board'].disable();
          this.academicDetailsForm.controls['twelth_subjects'].disable();
          this.academicDetailsForm.controls['twelth_year_of_passing'].disable();
          this.academicDetailsForm.controls['twelth_division_grade'].disable();
          this.academicDetailsForm.controls['highest_qualification'].disable();

          this.moreQualificationForm.controls['graduation_university'].disable();
          this.moreQualificationForm.controls['graduation_course'].disable();
          this.moreQualificationForm.controls['graduation_year_of_passing'].disable();
          this.moreQualificationForm.controls['graduation_division_grade'].disable();
          this.moreQualificationForm.controls['post_graduation_university'].disable();
          this.moreQualificationForm.controls['post_graduation_course'].disable();
          this.moreQualificationForm.controls['post_graduation_year_of_passing'].disable();
          this.moreQualificationForm.controls['post_graduation_division_grade'].disable();
          this.moreQualificationForm.controls['other_qualification_university'].disable();
          this.moreQualificationForm.controls['other_qualification_course'].disable();
          this.moreQualificationForm.controls['other_qualification_year_of_passing'].disable();
          this.moreQualificationForm.controls['other_qualification_division_grade'].disable();

          this.courseDetailForm.controls['program_id'].disable();
          this.courseDetailForm.controls['course_id'].disable();
          this.courseDetailForm.controls['branch_id'].disable();
        } else {
          this.submittedForm = false;
        }

        this.patchForm(data);
      }
    });
  }

  patchForm(data) {
    let applicationNo = (data && data['username']) ? data['username'] : this.user.username;
    let email = (data && data['email']) ? data['email'] : this.user.email;
    let contact = (data && data['contact']) ? data['contact'] : this.user.contact;
    let studentNameHindi = (data && data['name_hindi']) ? data['name_hindi'] : this.translateToHindi('STUDENT', this.user.name);
    let fatherNameHindi = (data && data['father_name_hindi']) ? data['father_name_hindi'] : '';
    let motherNameHindi = (data && data['mother_name_hindi']) ? data['mother_name_hindi'] : '';

    this.selectedSessionId = data.session.id;

    this.personalInfoForm.patchValue({
      'application_no': applicationNo,
      'admission_type': (data && data.admission_type) ? data.admission_type : '',
      'year': (data && data.year) ? data.year : '',
      'email': (data && data.email) ? data.email : email,
      'contact': (data && data.contact) ? data.contact : contact,
      'name': (data && data.name) ? data.name : '',
      'name_hindi': studentNameHindi,
      'father_name': (data && data.father_name) ? data.father_name : '',
      'father_name_hindi': fatherNameHindi,
      'mother_name': (data && data.mother_name) ? data.mother_name : '',
      'mother_name_hindi': motherNameHindi,
      'gender': (data && data.gender) ? data.gender : '',
      'dob': (data && data.dob) ? data.dob : '',
      'abc_id_no': (data && data.abc_id_no) ? data.abc_id_no : '',
      'deb_unique_id': (data && data.deb_unique_id) ? data.deb_unique_id : '',
      'govt_photo_id_no': (data && data.govt_photo_id_no) ? data.govt_photo_id_no : '',
      'session_id': (data && data.session && data.session.id) ? data.session.session_name : '',
    });
    this.filePhotograph = {
      'id': (data && data['student_photograph'] && data['student_photograph'].id) ? data['student_photograph'].id : '',
      'url': (data && data['student_photograph'] && data['student_photograph'].id) ? data['student_photograph'].url : '',
    };
    this.fileGovtPhotoId = {
      'id': (data && data['govt_photo'] && data['govt_photo'].id) ? data['govt_photo'].id : '',
      'url': (data && data['govt_photo'] && data['govt_photo'].id) ? data['govt_photo'].url : '',
    };
    this.fileSignature = {
      'id': (data && data['student_signature_pdf'] && data['student_signature_pdf'].id) ? data['student_signature_pdf'].id : '',
      'url': (data && data['student_signature_pdf'] && data['student_signature_pdf'].id) ? data['student_signature_pdf'].url : '',
    }
    this.fileAadharFrontSide = {
      'id': (data && data['student_aadhar_front'] && data['student_aadhar_front'].id) ? data['student_aadhar_front'].id : '',
      'url': (data && data['student_aadhar_front'] && data['student_aadhar_front'].id) ? data['student_aadhar_front'].url : '',
    };
    this.fileAadharBackSide = {
      'id': (data && data['student_aadhar_back'] && data['student_aadhar_back'].id) ? data['student_aadhar_back'].id : '',
      'url': (data && data['student_aadhar_back'] && data['student_aadhar_back'].id) ? data['student_aadhar_back'].url : '',
    };
    this.fileVoterId = {
      'id': (data && data['student_voter_id'] && data['student_voter_id'].id) ? data['student_voter_id'].id : '',
      'url': (data && data['student_voter_id'] && data['student_voter_id'].id) ? data['student_voter_id'].url : '',
    };
    this.filePanCard = {
      'id': (data && data['student_pan_card_id'] && data['student_pan_card_id'].id) ? data['student_pan_card_id'].id : '',
      'url': (data && data['student_pan_card_id'] && data['student_pan_card_id'].id) ? data['student_pan_card_id'].url : '',
    };
    this.fileDrivingLicence = {
      'id': (data && data['student_driving_licence'] && data['student_driving_licence'].id) ? data['student_driving_licence'].id : '',
      'url': (data && data['student_driving_licence'] && data['student_driving_licence'].id) ? data['student_driving_licence'].url : '',
    };
    this.fileOtherGovermentID = {
      'id': (data && data['student_other_government_id'] && data['student_other_government_id'].id) ? data['student_other_government_id'].id : '',
      'url': (data && data['student_other_government_id'] && data['student_other_government_id'].id) ? data['student_other_government_id'].url : '',
    };

    this.addressForm.patchValue({
      'address': (data && data.address) ? data.address : '',
      'state_id': (data && data.state_id) ? data.state_id : '',
      'country_id': (data && data.country_id) ? data.country_id : '',
      'city': (data && data.city) ? data.city : '',
      'pin_code': (data && data.pin_code) ? data.pin_code : '',
      'category': (data && data.category) ? data.category : '',
      'employment_status': (data && data.employment_status) ? data.employment_status : '',
      'locality': (data && data.locality) ? data.locality : ''
    });

    this.academicDetailsForm.patchValue({
      'tenth_board': (data && data.tenth_board) ? data.tenth_board : '',
      'tenth_subjects': (data && data.tenth_subjects) ? data.tenth_subjects : '',
      'tenth_year_of_passing': (data && data.tenth_year_of_passing) ? data.tenth_year_of_passing : '',
      'tenth_division_grade': (data && data.tenth_division_grade) ? data.tenth_division_grade : '',
      'twelth_board': (data && data.twelth_board) ? data.twelth_board : '',
      'twelth_subjects': (data && data.twelth_subjects) ? data.twelth_subjects : '',
      'twelth_year_of_passing': (data && data.twelth_year_of_passing) ? data.twelth_year_of_passing : '',
      'twelth_division_grade': (data && data.twelth_division_grade) ? data.twelth_division_grade : '',
      'highest_qualification': (data && data.highest_qualification) ? data.highest_qualification : '',
    });
    this.fileTenthCertificate = {
      'id': (data && data['tenth_certificate'] && data['tenth_certificate'].id) ? data['tenth_certificate'].id : '',
      'url': (data && data['tenth_certificate'] && data['tenth_certificate'].id) ? data['tenth_certificate'].url : '',
    };
    this.fileTwelthCertificate = {
      'id': (data && data['twelth_certificate'] && data['twelth_certificate'].id) ? data['twelth_certificate'].id : '',
      'url': (data && data['twelth_certificate'] && data['twelth_certificate'].id) ? data['twelth_certificate'].url : '',
    };

    this.moreQualificationForm.patchValue({
      'graduation_university': (data && data.graduation_university) ? data.graduation_university : '',
      'graduation_course': (data && data.graduation_course) ? data.graduation_course : '',
      'graduation_year_of_passing': (data && data.graduation_year_of_passing) ? data.graduation_year_of_passing : '',
      'graduation_division_grade': (data && data.graduation_division_grade) ? data.graduation_division_grade : '',
      'post_graduation_university': (data && data.post_graduation_university) ? data.post_graduation_university : '',
      'post_graduation_course': (data && data.post_graduation_course) ? data.post_graduation_course : '',
      'post_graduation_year_of_passing': (data && data.post_graduation_year_of_passing) ? data.post_graduation_year_of_passing : '',
      'post_graduation_division_grade': (data && data.post_graduation_division_grade) ? data.post_graduation_division_grade : '',
      'other_qualification_university': (data && data.other_qualification_university) ? data.other_qualification_university : '',
      'other_qualification_course': (data && data.other_qualification_course) ? data.other_qualification_course : '',
      'other_qualification_year_of_passing': (data && data.other_qualification_year_of_passing) ? data.other_qualification_year_of_passing : '',
      'other_qualification_division_grade': (data && data.other_qualification_division_grade) ? data.other_qualification_division_grade : '',
    });
    this.fileGraduationCertificate = {
      'id': (data && data['graduation_certificate'] && data['graduation_certificate'].id) ? data['graduation_certificate'].id : '',
      'url': (data && data['graduation_certificate'] && data['graduation_certificate'].id) ? data['graduation_certificate'].url : '',
    };
    this.filePostGraduationCertificate = {
      'id': (data && data['post_graduation_certificate'] && data['post_graduation_certificate'].id) ? data['post_graduation_certificate'].id : '',
      'url': (data && data['post_graduation_certificate'] && data['post_graduation_certificate'].id) ? data['post_graduation_certificate'].url : '',
    };
    this.fileOtherQualificationCertificate = {
      'id': (data && data['other_qualification_certificate'] && data['other_qualification_certificate'].id) ? data['other_qualification_certificate'].id : '',
      'url': (data && data['other_qualification_certificate'] && data['other_qualification_certificate'].id) ? data['other_qualification_certificate'].url : '',
    };
    this.getStudentProgram(data);
  }

  getStudentProgram(data) {
    this.pcbMappingService.get({'page': -1, 'status': 'ACTIVE', 'course_id': data['course_id']}).subscribe(dp => {
      if (dp && dp['data'].length > 0) {
        this.selectedProgram = Helper.uniqByKeepLast(dp['data'], it => it.program_id);
        if (this.selectedProgram && this.selectedProgram.length > 0) {
          this.courseDetailForm.patchValue({
            'program_id': this.selectedProgram[0].program_id
          });
          this.getCoursesByProgramId(this.selectedProgram[0].program_id, data);
        }
      }
    });
  }

  admissionType(event) {
    if (event.target.value === 'FRESH_ADMISSION') {
      this.personalInfoForm.patchValue({
        'year': 1
      });
    } else if (event.target.value === 'LATERAL_ENTRY') {
      this.personalInfoForm.patchValue({
        'year': 2
      });
    } else {
      this.personalInfoForm.patchValue({
        'year': ''
      });
    }
  }
  openSignatureUploadModal(content) {
    this.modalType = 'SIGNATURE_MODAL';
    this.modalService.open(content);
  }
  openImageUploadModal(content) {
    this.modalType = 'PHOTOGRAPH_MODAL';
    this.modalService.open(content);
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageEvent = event;
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  onImageChange(e) {
    this.imageChangedEvent = e;
  }

  getHindiName(type, event) {
    if (type === 'FATHER' || type === 'MOTHER' || type === 'STUDENT') {
      if (event && event.target && event.target.value) {
        this.translateToHindi(type, event.target.value);
      } else {
        if (type === 'FATHER') {
          this.personalInfoForm.patchValue({
            'father_name_hindi': ''
          });
        } else if (type === 'MOTHER') {
          this.personalInfoForm.patchValue({
            'mother_name_hindi': ''
          });
        } else if (type === 'STUDENT') {
          this.personalInfoForm.patchValue({
            'student_name_hindi': ''
          });
        }
      }
    } else if (type === 'STUDENT_ONINIT') {
      if (event) {
        this.translateToHindi(type, event);
      } else {
        this.personalInfoForm.patchValue({
          'admission_type': ''
        });
      }
    }
  }

  translateToHindi(type, name) {
    this.personalInfoService.translate({'name': name}).subscribe(data => {
      if (type === 'FATHER') {
        this.personalInfoForm.patchValue({
          'father_name_hindi': (data && data['name']) ? data['name'] : ''
        });
      } else if (type === 'MOTHER') {
        this.personalInfoForm.patchValue({
          'mother_name_hindi': (data && data['name']) ? data['name'] : ''
        });
      } else if (type === 'STUDENT') {
        this.personalInfoForm.patchValue({
          'name_hindi': (data && data['name']) ? data['name'] : ''
        });
      } else if (type === 'STUDENT_ONINIT') {
        this.personalInfoForm.patchValue({
          'name_hindi': (data && data['name']) ? data['name'] : ''
        });
      }
    }, error => {
      this.alertService.showErrors('Error in translation, please try again');
    });
  }

  savePhotograph() {
    this.docSubmittingPhotograph = true;
    if (this.docSubmittingPhotograph) {
      const params = {
        'type': 'STUDENT_PHOTOGRAPH',
        'user_id': this.user.user_id,
        'fileType': 'BASE64'
      };
      this.fileService.fileUpload(params, this.croppedImage).subscribe(data => {
        if (data) {
          this.filePhotograph = {'id': data['data'].id, 'url': data['data'].url};
          this.photographImage = data['data'].url;
          this.imageChangedProfileEvent = undefined;
          this.updatePhotograph(data['data'].id);
        }
      }, error => {
        this.docSubmittingPhotograph = false;
      });
    }
  }
  saveSignature() {
    const params = {
      'type': 'STUDENT_SIGNATURE',
      'user_id': this.user.user_id,
      'fileType': 'BASE64'
    };
    this.fileService.fileUpload(params, this.croppedImage).subscribe(data => {
      if (data) {
        this.fileSignature = {'id': data['data'].id, 'url': data['data'].url};
        this.signImage = data['data'].url;
        this.signChangedProfileEvent = undefined;
        this.updateSignature(data['data'].id);
      }
    });
  }
  updateSignature(id) {
    this.personalInfoService.updateSignature({
      'student_signature': id,
      'session_id': this.selectedSessionId
    }).subscribe(data => {
      this.modalService.dismissAll('');
    });
    this.modalService.dismissAll('');
    this.alertService.showSuccess({'title': 'success', 'message': 'Image successfully loaded'});
  }
  goTo(url) {
    window.open(url, '_blank');
  }

  updatePhotograph(id) {
    this.personalInfoService.updatePhotograph({
      'student_photograph': id,
      'session_id': this.selectedSessionId
    }).subscribe(data => {
      this.docSubmittingPhotograph = false;
      this.modalService.dismissAll('');
    }, error => {
      this.docSubmittingPhotograph = false;
    });
    this.modalService.dismissAll('');
    this.alertService.showSuccess({'title': 'success', 'message': 'Image successfully loaded'});
  }

  onFileChange(e, type) {
    this.onFileChanged = e;
    if (type === 'GOVT_PHOTO_ID') {
      this.docSubmittingGovtPhotoId = true;
    } else if (type === 'TENTH_CERTIFICATE') {
      this.docSubmittingTenthCertificate = true;
    } else if (type === 'TWELTH_CERTIFICATE') {
      this.docSubmittingTwelthCertificate = true;
    } else if (type === 'GRADUATION_CERTIFICATE') {
      this.docSubmittingGraduationCertificate = true;
    } else if (type === 'POST_GRADUATION_CERTIFICATE') {
      this.docSubmittingPostGraduationCertificate = true;
    } else if (type === 'OTHER_QUALIFICATION_CERTIFICATE') {
      this.docSubmittingOtherQualificationCertificate = true;
    }
    this.fileService.fileUpload({'type': type, 'fileType': 'NORMAL'}, this.onFileChanged).subscribe(data => {
      if (type === 'GOVT_PHOTO_ID') {
        this.fileGovtPhotoId = data['data'];
      } else if (type === 'AADHAR_FRONT') {
        this.fileAadharFrontSide = data['data'];
      } else if (type === 'AADHAR_BACK') {
        this.fileAadharBackSide = data['data'];
      } else if (type === 'VOTER_ID') {
        this.fileVoterId = data['data'];
      } else if (type === 'PAN_CARD') {
        this.filePanCard = data['data'];
      } else if (type === 'DRIVING_LICENCE') {
        this.fileDrivingLicence = data['data'];
      } else if (type === 'OTHERS_GOVERNMENT_ID') {
        this.fileOtherGovermentID = data['data'];
      }  else if (type === 'TENTH_CERTIFICATE') {
        this.fileTenthCertificate = data['data'];
      } else if (type === 'TWELTH_CERTIFICATE') {
        this.fileTwelthCertificate = data['data'];
      } else if (type === 'GRADUATION_CERTIFICATE') {
        this.fileGraduationCertificate = data['data'];
      } else if (type === 'POST_GRADUATION_CERTIFICATE') {
        this.filePostGraduationCertificate = data['data'];
      } else if (type === 'OTHER_QUALIFICATION_CERTIFICATE') {
        this.fileOtherQualificationCertificate = data['data'];
      }
      this.updateCertificate(type, data['data']);
      this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
    }, error => {
      this.alertService.showErrors('Something went wrong, please try again');
    });
  }

  updateCertificate(type, data) {
    if (type === 'GOVT_PHOTO_ID') {
      this.personalInfoService.updateGovtPhotoId({
        'govt_photo_id': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.docSubmittingGovtPhotoId = false;
        this.submitting = false;
        this.submitted = false;
      }, error => {
        this.docSubmittingGovtPhotoId = false;
      });
    } else if (type === 'AADHAR_FRONT') {
      this.personalInfoService.updateAadharFront({
        'aadhar_front': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
      });
    } else if (type === 'AADHAR_BACK') {
      this.personalInfoService.updateAadharBack( {
        'aadhar_back': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
      });
    } else if (type === 'VOTER_ID') {
      this.personalInfoService.updateVoterId({
        'voter_id': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
      });
    } else if (type === 'PAN_CARD') {
      this.personalInfoService.updatePanCard({
        'pan_card_id': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
      });
    } else if (type === 'DRIVING_LICENCE') {
      this.personalInfoService.updateDrivingLicence({
        'driving_licence': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
      });
    } else if (type === 'OTHERS_GOVERNMENT_ID') {
      this.personalInfoService.updateOtherGovernmentId({
        'other_government_id': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
      });
    } else if (type === 'TENTH_CERTIFICATE') {
      this.academicDetailsService.updateTenthCertificate({
        'tenth_certificate': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.docSubmittingTenthCertificate = false;
        this.submitting = false;
        this.submitted = false;
      }, error => {
        this.docSubmittingTenthCertificate = false;
      });
    } else if (type === 'TWELTH_CERTIFICATE') {
      this.academicDetailsService.updateTwelthCertificate({
        'twelth_certificate': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.docSubmittingTwelthCertificate = false;
        this.submitting = false;
        this.submitted = false;
      }, error => {
        this.docSubmittingTwelthCertificate = false;
      });
    } else if (type === 'GRADUATION_CERTIFICATE') {
      this.moreQualificationsService.updateGraduationCertificate({
        'graduation_certificate': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.docSubmittingGraduationCertificate = false;
        this.submitting = false;
        this.submitted = false;
      }, error => {
        this.docSubmittingGraduationCertificate = false;
      });
    } else if (type === 'POST_GRADUATION_CERTIFICATE') {
      this.moreQualificationsService.updatePostGraduationCertificate({
        'post_graduation_certificate': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.docSubmittingPostGraduationCertificate = false;
        this.submitting = false;
        this.submitted = false;
      }, error => {
        this.docSubmittingPostGraduationCertificate = false;
      });
    } else if (type === 'OTHER_QUALIFICATION_CERTIFICATE') {
      this.moreQualificationsService.updateOtherQualificationCertificate({
        'other_qualification_certificate': data.id,
        'session_id': this.selectedSessionId
      }).subscribe(data => {
        this.docSubmittingOtherQualificationCertificate = false;
        this.submitting = false;
        this.submitted = false;
      }, error => {
        this.docSubmittingOtherQualificationCertificate = false;
      });
    }
  }

  submitPersonalInfo() {
    this.submitted = true;
    if (!this.personalInfoForm.valid) {
      return;
    }
    if (this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().dob) {
      let dob = this.personalInfoForm.getRawValue().dob;
      let yearOfBirth = dob.split('-')[0];
      if (parseInt(yearOfBirth) > 2007 || parseInt(yearOfBirth) < 1960) {
        this.alertService.showErrors('Invalid Date Of Birth');
        return;
      }
    }
    if (!this.filePhotograph || !this.filePhotograph.id || !this.filePhotograph.url) {
      this.alertService.showErrors('Upload your photograph to proceed');
      return;
    }

    if (this.submitted) {
      const params = {
        'admission_type': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().admission_type) ? this.personalInfoForm.getRawValue().admission_type : '',
        'year': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().year) ? this.personalInfoForm.getRawValue().year : '',
        'name_hindi': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().name_hindi) ? this.personalInfoForm.getRawValue().name_hindi : '',
        'father_name': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().father_name) ? this.personalInfoForm.getRawValue().father_name : '',
        'father_name_hindi': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().father_name_hindi) ? this.personalInfoForm.getRawValue().father_name_hindi : '',
        'mother_name': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().mother_name) ? this.personalInfoForm.getRawValue().mother_name : '',
        'mother_name_hindi': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().mother_name_hindi) ? this.personalInfoForm.getRawValue().mother_name_hindi : '',
        'gender': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().gender) ? this.personalInfoForm.getRawValue().gender : '',
        'dob': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().dob) ? this.personalInfoForm.getRawValue().dob : '',
        'abc_id_no': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().abc_id_no) ? this.personalInfoForm.getRawValue().abc_id_no : '',
        'deb_unique_id': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().deb_unique_id) ? this.personalInfoForm.getRawValue().deb_unique_id : '',
        'govt_photo_id_no': (this.personalInfoForm && this.personalInfoForm.getRawValue() && this.personalInfoForm.getRawValue().govt_photo_id_no) ? this.personalInfoForm.getRawValue().govt_photo_id_no : '',
        'session_id': this.selectedSessionId
      };
      this.personalInfoService.create(params).subscribe(data => {
        this.submitted = false;
        this.wizard.goToNextStep();
      }, error => {
        this.submitted = false;
      });
    }
  }

  submitAddress() {
    this.submitted = true;
    if (!this.addressForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'address': (this.addressForm && this.addressForm.getRawValue() && this.addressForm.getRawValue().address) ? this.addressForm.getRawValue().address : '',
        'state_id': (this.addressForm && this.addressForm.getRawValue() && this.addressForm.getRawValue().state_id) ? this.addressForm.getRawValue().state_id : '',
        'country_id': (this.addressForm && this.addressForm.getRawValue() && this.addressForm.getRawValue().country_id) ? this.addressForm.getRawValue().country_id : '',
        'city': (this.addressForm && this.addressForm.getRawValue() && this.addressForm.getRawValue().city) ? this.addressForm.getRawValue().city : '',
        'pin_code': (this.addressForm && this.addressForm.getRawValue() && this.addressForm.getRawValue().pin_code) ? this.addressForm.getRawValue().pin_code : '',
        'category': (this.addressForm && this.addressForm.getRawValue() && this.addressForm.getRawValue().category) ? this.addressForm.getRawValue().category : '',
        'employment_status': (this.addressForm && this.addressForm.getRawValue() && this.addressForm.getRawValue().employment_status) ? this.addressForm.getRawValue().employment_status : '',
        'locality': (this.addressForm && this.addressForm.getRawValue() && this.addressForm.getRawValue().locality) ? this.addressForm.getRawValue().locality : '',
        'session_id': this.selectedSessionId
      };
      this.addressService.create(params).subscribe(data => {
        this.submitted = false;
        this.wizard.goToNextStep();
      }, error => {
        this.submitted = false;
      });
    }
  }

  submitAcademicDetails() {
    this.submitted = true;
    if (!this.academicDetailsForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'tenth_board': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().tenth_board) ? this.academicDetailsForm.getRawValue().tenth_board : '',
        'tenth_subjects': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().tenth_subjects) ? this.academicDetailsForm.getRawValue().tenth_subjects : '',
        'tenth_year_of_passing': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().tenth_year_of_passing) ? this.academicDetailsForm.getRawValue().tenth_year_of_passing : '',
        'tenth_division_grade': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().tenth_division_grade) ? this.academicDetailsForm.getRawValue().tenth_division_grade : '',
        'twelth_board': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().twelth_board) ? this.academicDetailsForm.getRawValue().twelth_board : '',
        'twelth_subjects': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().twelth_subjects) ? this.academicDetailsForm.getRawValue().twelth_subjects : '',
        'twelth_year_of_passing': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().twelth_year_of_passing) ? this.academicDetailsForm.getRawValue().twelth_year_of_passing : '',
        'highest_qualification': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().highest_qualification) ? this.academicDetailsForm.getRawValue().highest_qualification : '',
        'twelth_division_grade': (this.academicDetailsForm && this.academicDetailsForm.getRawValue() && this.academicDetailsForm.getRawValue().twelth_division_grade) ? this.academicDetailsForm.getRawValue().twelth_division_grade : '',
        'session_id': this.selectedSessionId
      };
      this.academicDetailsService.create(params).subscribe(data => {
        this.submitted = false;
        this.wizard.goToNextStep();
      }, error => {
        this.submitted = false;
      });
    }
  }

  submitMoreQualifications() {
    this.submitted = true;
    if (!this.moreQualificationForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'graduation_university': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().graduation_university) ? this.moreQualificationForm.getRawValue().graduation_university : '',
        'graduation_course': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().graduation_course) ? this.moreQualificationForm.getRawValue().graduation_course : '',
        'graduation_year_of_passing': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().graduation_year_of_passing) ? this.moreQualificationForm.getRawValue().graduation_year_of_passing : '',
        'graduation_division_grade': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().graduation_division_grade) ? this.moreQualificationForm.getRawValue().graduation_division_grade : '',
        'post_graduation_university': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().post_graduation_university) ? this.moreQualificationForm.getRawValue().post_graduation_university : '',
        'post_graduation_course': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().post_graduation_course) ? this.moreQualificationForm.getRawValue().post_graduation_course : '',
        'post_graduation_year_of_passing': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().post_graduation_year_of_passing) ? this.moreQualificationForm.getRawValue().post_graduation_year_of_passing : '',
        'post_graduation_division_grade': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().post_graduation_division_grade) ? this.moreQualificationForm.getRawValue().post_graduation_division_grade : '',
        'other_qualification_university': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().other_qualification_university) ? this.moreQualificationForm.getRawValue().other_qualification_university : '',
        'other_qualification_course': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().other_qualification_course) ? this.moreQualificationForm.getRawValue().other_qualification_course : '',
        'other_qualification_year_of_passing': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().other_qualification_year_of_passing) ? this.moreQualificationForm.getRawValue().other_qualification_year_of_passing : '',
        'other_qualification_division_grade': (this.moreQualificationForm && this.moreQualificationForm.getRawValue() && this.moreQualificationForm.getRawValue().other_qualification_division_grade) ? this.moreQualificationForm.getRawValue().other_qualification_division_grade : '',
        'session_id': this.selectedSessionId
      };
      this.moreQualificationsService.create(params).subscribe(data => {
        this.submitted = false;
        this.wizard.goToNextStep();
      }, error => {
        this.submitted = false;
        this.wizard.goToNextStep();
      });
    }
  }

  public submitCourse() {
    this.submitted = true;
    if (!this.courseDetailForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'program_id': (this.courseDetailForm && this.courseDetailForm.getRawValue() && this.courseDetailForm.getRawValue().program_id) ? this.courseDetailForm.getRawValue().program_id : '',
        'course_id': (this.courseDetailForm && this.courseDetailForm.getRawValue() && this.courseDetailForm.getRawValue().course_id) ? this.courseDetailForm.getRawValue().course_id : '',
        'branch_id': (this.courseDetailForm && this.courseDetailForm.getRawValue() && this.courseDetailForm.getRawValue().branch_id) ? this.courseDetailForm.getRawValue().branch_id : '',
        'unique_id': this.studentData.unique_id,
        'session_id': this.selectedSessionId
      };
      this.courseDetailsService.create(params).subscribe(data => {
        this.submitted = false;
        this.getPCBMapping({
          'program_id': (this.courseDetailForm && this.courseDetailForm.getRawValue() && this.courseDetailForm.getRawValue().program_id) ? this.courseDetailForm.getRawValue().program_id : '',
          'course_id': (this.courseDetailForm && this.courseDetailForm.getRawValue() && this.courseDetailForm.getRawValue().course_id) ? this.courseDetailForm.getRawValue().course_id : '',
          'branch_id': (this.courseDetailForm && this.courseDetailForm.getRawValue() && this.courseDetailForm.getRawValue().branch_id) ? this.courseDetailForm.getRawValue().branch_id : '',
          'session_id': this.selectedSessionId
        });
        this.wizard.goToNextStep();
      }, error => {
        this.submitted = false;
      });
    }
  }

  payNow(type) {
    /*this.alertService.showErrors('Payment services are temporarily unavailable at the moment but will be resumed shortly.');
    return false;*/
    this.paymentService.update(this.studentData.unique_id, {
      'session_id': this.selectedSessionId,
      'callback_url': 'https://student.cdoevgu.com/general/application-form',
      'type': type
    }).subscribe(data => {
      if (data) {
        this.paymentUrl(data.url);
      } else {
        this.alertService.showErrors('Something went wrong, please try again later');
      }
    }, error => {
      this.alertService.showErrors('Something went wrong, please try again later');
      this.submitted = false;
    });
  }

  paymentUrl(url) {
    window.location.replace(url);
  }
  onDocumentTypeChange(value: string) {
    this.selectedDocumentType = value;
  }
  openUrl(data) {
    let url = environment.appUrl + 'registration/payment-receipt/' + data.unique_id + '-' + data.session_id ;
    window.open(url, '_blank');
  }
  openCompleteUrl(data){
    let url = environment.appUrl + 'admission/payment-receipt/' + data.unique_id + '-' + data.session_id ;
    window.open(url, '_blank');
  }
}
